import { TAppState } from '../../types/appState';

export function openedChatsSelector(state: TAppState) {
  return state.openedChats;
}
